import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import validator from 'validator';
import { authService } from '../../Services';
import { authActions } from '../../Actions';
import jwtDecode from 'jwt-decode';

const Register = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  
  const { from } = location.state || { from: { pathname: "/user/home" } };
  
  const auth = useSelector((state) => state.auth);
  useEffect(() => {
    // window.location = process.env.REACT_APP_MICROSITE_URL;
    if (auth && auth.token) {
      return navigate(from);
    }
  }, []);

  const [input, setInput] = useState({
    nationality: '',
    firstname: '',
    lastname: '',
    username: '',
    phone: '',
    password: '',
    confirm_password: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const submitRegister = () => {
    if(Object.keys(checkValidation()).length > 0) {
      setSubmitted(false);
      return false;
    }
    authService.register(input).then(auth => {
      setSubmitted(false);
      if (auth.status == 0) {
        return;
      }
      navigate("/login");
    });
  }
  
  const [validationError, setValidationError] = useState({});
  const ref = useRef([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInput(input => ({ ...input, [name]: value }));
  }

  const checkValidation = () => {
    let error = {};
    Object.keys(input).map(item => {
      if(input[item] == "" && item != "user_status") {
        error[item] = "Required";
      }

      if(input[item]) {
        switch(item) {
          case "phone":
            if(!validator.isNumeric(String(input['phone']))) {
              error[item] =  "Invalid phone number";
            }
            break;
          case "username":
            if(!validator.isEmail(input['username'])) {
              error[item] =  "Invalid email";
            }
            break;
          case "confirm_password":
            if(input['password'] != input['confirm_password']) {
              error[item] =  "Password and confirm password are not matching";
            }
            break;
          
          default:
            break;
        }
      }
    });
    if(Object.keys(error).length>0) {
      setValidationError(error);
      const ref_focus_key = Object.keys(error)[0];
      ref.current[ref_focus_key].focus();
    }
    return error;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    submitRegister(from);
  }


  return (
    <>
      {/* <section id="page-banner" className="pt-10 pb-10 bg_cover" data-overlay="8" style={{ backgroundImage: "url(images/fellowship-programme.jpg)" }}>
              <div className="container">
                  <div className="row">
                      <div className="col-lg-12">
                          <div className="page-banner-cont">
                              <h2>Register</h2>
                              <nav aria-label="breadcrumb">
                                  <ol className="breadcrumb">
                                      <li className="breadcrumb-item"><Link to={"/"}>Home</Link></li>
                                      <li className="breadcrumb-item active" aria-current="page">register</li>
                                  </ol>
                              </nav>
                          </div>
                      </div>
                  </div>
              </div>
          </section> */}

      <section className="pt-20 pb-50 page-background">
        <div className="container">
          <div className="row">
            <div className="contact-from">
              <div className="main-form">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="singel-form form-group">
                        <select name="nationality" ref={r => {ref.current['nationality'] = r}} onChange={handleChange} >
                          <option selected value="">-- Select Nationality --</option>
                          <option>Afghanistan</option>
                          <option>Antigua & Barbuda</option>
                          <option>Argentina</option>
                          <option>Australia</option>
                          <option>Bangladesh</option>
                          <option>Bhutan</option>
                          <option>Brazil</option>
                          <option>Canada</option>
                          <option>Chile</option>
                          <option>Cuba</option>
                          <option>Dominican Republic</option>
                          <option>Fiji</option>
                          <option>France</option>
                          <option>Germany</option>
                          <option>Ghana</option>
                          <option>Guatemala</option>
                          <option>Guyana</option>
                          <option>Haiti</option>
                          <option>Honduras</option>
                          <option>India</option>
                          <option>Italy</option>
                          <option>Jamaica</option>
                          <option>Japan</option>
                          <option>Madagascar</option>
                          <option>Maldives</option>
                          <option>Mauritius</option>
                          <option>Mongolia</option>
                          <option>Nauru</option>
                          <option>Nepal</option>
                          <option>Netherlands</option>
                          <option>Peru</option>
                          <option>Samoa</option>
                          <option>South Sudan</option>
                          <option>Sri Lanka</option>
                          <option>Tajikistan</option>
                          <option>Tonga</option>
                          <option>Türkiye</option>
                          <option>United Kingdom</option>
                          <option>United States of America</option>
                          <option>Vietnam</option>
                        </select>
                        {validationError.nationality && <span className='text-danger'>{validationError.nationality}</span>}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className='row'>
                        <div className="col-md-6 singel-form form-group">
                          <input name="firstname" type="text" value={input.firstname? input.firstname: ""} ref={r => {ref.current['firstname'] = r}} onChange={handleChange} placeholder="First Name" />
                          {validationError.firstname && <span className='text-danger'>{validationError.firstname}</span>}
                        </div>
                        <div className="col-md-6 singel-form form-group">
                          <input name="lastname" type="text" value={input.lastname? input.lastname: ""} ref={r => {ref.current['lastname'] = r}} onChange={handleChange} placeholder="Last Name" />
                          {validationError.lastname && <span className='text-danger'>{validationError.lastname}</span>}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className='row'>
                        <div className="col-md-6 singel-form form-group">
                          <input name="username" type="text" value={input.username? input.username: ""} ref={r => {ref.current['username'] = r}} onChange={handleChange} placeholder="Your Email" />
                          {validationError.username && <span className='text-danger'>{validationError.username}</span>}
                        </div>
                        <div className="col-md-6 singel-form form-group">
                          <input name="phone" type="text" value={input.phone? input.phone: ""} ref={r => {ref.current['phone'] = r}} onChange={handleChange} placeholder="Phone Number" />
                          {validationError.phone && <span className='text-danger'>{validationError.phone}</span>}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className='row'>
                        <div className="col-md-6 singel-form form-group">
                          <input name="password" type="password" value={input.password? input.password: ""} ref={r => {ref.current['password'] = r}} onChange={handleChange} placeholder="Your Password" />
                          {validationError.password && <span className='text-danger'>{validationError.password}</span>}
                        </div>
                        <div className="col-md-6 singel-form form-group">
                          <input name="confirm_password" type="password" value={input.confirm_password? input.confirm_password: ""} ref={r => {ref.current['confirm_password'] = r}} onChange={handleChange} placeholder="Confirm Password" />
                          {validationError.confirm_password && <span className='text-danger'>{validationError.confirm_password}</span>}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="singel-form">
                        <button type="submit" className="main-btn disabled">
                          {submitted ? <span><FontAwesomeIcon icon={faSpinner} className="fa-spin" /> Please wait</span> : <span>Register</span>}
                        </button>
                      </div>
                    </div>
                    <p className="form-message"></p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Register;